import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import CInput from '@/components/CForm/CInput'
import { insertStoreList, editStoreList} from "@/servers/storeManageApi";
import {setPageNewItem, urlFormat} from "@/utils";
import './index.scss'
import {Button, Modal, Tooltip} from "antd";
import wenhao from '@/assets/images/wenhao.png'
import important from '@/assets/images/important.png'
import { compose } from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../../../servers/menuAPI";
import store from "../../../../../../redux";
import { getStorage} from "@/utils";

@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }


  state = {
    data: [],
    addressInfo: null,
    searchData: {
      value: '',//搜索框筛选
      placeholder: '请输入评分'
    },
    isModalVisible:false
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  onChange(data){
    let currentOption = null;
    if(data.data.id === 'address'){
      currentOption = data.data.options.filter(item=>{
        return item.value === data.value;
      });
    }
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value),
      addressInfo: currentOption && currentOption.length ? currentOption[0] : null
    })
  }

  onSearch(data, value){
    if(data.data.id === 'address'){
      this.getAMapKeywordsSearchData(data.value);
    }else if(data.data.id === 'user'){
      this.getUserBusniessListData(data);
    }
  }


  onSubmit(data){
    if(data.data.avatarImg){
      let imgArr = [];
      data.data.avatarImg.forEach(item=>{
        imgArr.push({
          id: item.uid,
          url: item.url
        })
      });
      data.data.avatarImg = imgArr.length ? imgArr[0] : '';
    }
    let method = null;
    if(urlFormat(this.props.history.location.search).query.type === 'edit'){
      data.data.id = urlFormat(this.props.history.location.search).query.id;
      method = editStoreList;
    }else{
      method = insertStoreList
    }

    data.data.address = this.state.addressInfo ? this.state.addressInfo.name : '';
    data.data.latlong = this.state.addressInfo ? this.state.addressInfo.location : [0,0];

    method(data.data).then(res=>{
      this.props.history.goBack();
    }).catch(err=>{

    });
  }

  onSelect(){
    const params = {
      annual:getStorage('year'),
      indid:'1.1.2',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      res.records.forEach(item=>{
        item.pff = ''
      })
      this.setState({
        data:res.records
      })
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
      <div className='detail-container' id="top">
        {this.state.data.map(item=>{
          return (
              <div className="detail-item">
                <div className='detail-title'>
                   <span style={{display:"flex",alignItems:'center'}}>
                      <div style={{width:'90%'}}>{item.name}</div>
                      {item.formtips?
<Tooltip placement="left" title={this.computedData(decodeURIComponent(item.formtips))}>                            <span style={{color:'orange',marginLeft:'10px',cursor:'pointer',width:'85px',display:'block'}}>评分要点</span>
                          </Tooltip>:''
                      }
                    </span>
                  <div className='detail-score'>
                    <span className='required'>*</span>
                    <CInput value={item.pff}
                            className='search-input'
                            placeholder={this.state.searchData.placeholder} />
                    <div className='scoreintro'>(0-10分)</div>
                    <Tooltip placement="bottom" title='打分说明'>
                      <img src={wenhao} alt="" style={{width:'15px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
                    </Tooltip>
                  </div>
                </div>
                <div className='detail-content'>
                  {item.fillin}
                </div>
                <div className='detail-info'>
                  <div className='info-icon'>
                    <img src={important} alt=""/>
                  </div>
                  <div>
                    {item.tips}
                  </div>
                </div>
              </div>
          )
        })}
        <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
          <Button type="primary" className='yl'>确定</Button>
          <Button>取消</Button>
        </div>
        <Modal title="附件预览" visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
            <div style={{width:'100%',minHeight:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};

export default compose(withRouter, connect(mapStateToProps))(Legal);
